import { styled } from '@linaria/react';
export const OverlayContent = /*#__PURE__*/styled('div')({
  name: "OverlayContent",
  class: "o1mteveo",
  propsAsIs: false
});
export const HotelCardWrapper = /*#__PURE__*/styled('div')({
  name: "HotelCardWrapper",
  class: "htkakfq",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.tsx");